import { useInternalDynamicContext } from '../../../context/DynamicContext/useInternalDynamicContext.js';
import { useViewContext } from '../../../context/ViewContext/ViewContext.js';

const useHandleWalletsToConnect = () => {
    const { walletsToConnectByChain, setWalletsToConnectByChain, setShowAuthFlow, setIsFullyConnected, selectedWalletConnector, isFullyConnected, } = useInternalDynamicContext();
    const { setView, goToInitialView } = useViewContext();
    const handleWalletsToConnect = () => {
        if (!walletsToConnectByChain) {
            setIsFullyConnected(true);
            setShowAuthFlow(false);
            return;
        }
        // Avoid showing wallet-list when wallet updates network to the correct one in run time (bridge mode)
        if (walletsToConnectByChain.length === 0) {
            setShowAuthFlow(false);
            return goToInitialView();
        }
        if (!selectedWalletConnector || !selectedWalletConnector.connectedChain) {
            setShowAuthFlow(false);
            return goToInitialView();
        }
        // Assuming based on the logic above that we have at least one more chain/wallet to connect
        // If the current connected wallet is already connected to the bridge,
        // we can go directly to bridge-next-wallet-connection since we know there is a different chain to connect
        const walletChainsToConnect = walletsToConnectByChain
            .filter((wallet) => wallet.numberOfWallets > 0)
            .map((wallet) => wallet.chain.toString());
        if (!walletChainsToConnect.includes(selectedWalletConnector.connectedChain)) {
            setView('bridge-next-wallet-connection');
            return;
        }
        const [firstWallet, ...restOfTheWallets] = walletsToConnectByChain;
        if (firstWallet.numberOfWallets > 1) {
            const updatedWallets = [
                Object.assign(Object.assign({}, firstWallet), { numberOfWallets: firstWallet.numberOfWallets - 1 }),
                ...restOfTheWallets,
            ];
            setWalletsToConnectByChain(updatedWallets);
            setView('wallet-list');
            return;
        }
        setWalletsToConnectByChain(restOfTheWallets);
        const allWalletsConnected = restOfTheWallets.length === 0;
        if (allWalletsConnected) {
            if (!isFullyConnected) {
                setIsFullyConnected(true);
                setView('bridge-summary');
            }
            else {
                setShowAuthFlow(false);
                goToInitialView();
            }
            return;
        }
        setView('bridge-next-wallet-connection');
    };
    return { handleWalletsToConnect };
};

export { useHandleWalletsToConnect };
